import { Component, OnInit, Input } from '@angular/core';
import { BsModalService, BsModalRef } from 'ngx-bootstrap';

@Component({
  selector: 'app-parente-pf',
  templateUrl: './parente-pf.component.html',
  styleUrls: ['./../cadastral-pf/cadastral-pf.component.css','./parente-pf.component.css']
})
export class ParentePfComponent implements OnInit {

  @Input() dados:any;
  public txtButtonConsultar:string='Consultar agora';
  public consultando:Boolean=false;
  public naoSolicitou:Boolean=false;
  public naoEncontrouRegistros:Boolean=false;
  public modalRef:BsModalRef;

  constructor(private modalService:BsModalService) { }
  

  ngOnInit() {
    if(this.dados.relacionamento===undefined){
      this.naoSolicitou=true;
    }else if(this.dados.relacionamento===null){
      this.naoEncontrouRegistros=true;
    }
  }

}
